import { render, staticRenderFns } from "./forgot-username.component.vue?vue&type=template&id=9a79d960&"
import script from "./forgot-username.component.vue?vue&type=script&lang=ts&"
export * from "./forgot-username.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports